import BettoDefaultGameIcon from "@layouts/betto/assets/betto-default-game-icon.svg";

const DAY_MS = 24 * 60 * 60 * 1000;

export const BETTO_EAGER_IMAGE_COUNT = 8;

export const getBettoDefaultGameIcon = () => BettoDefaultGameIcon;

const preloadedImageUrls = new Set();

/**
 * Returns img loading attributes for betto game/thumb images.
 * First `eagerCount` items load immediately with high fetch priority.
 */
export const getBettoImageLoadingProps = (index, { eagerCount = BETTO_EAGER_IMAGE_COUNT } = {}) => {
	const isEager = typeof index === "number" && index >= 0 && index < eagerCount;

	return {
		loading: isEager ? "eager" : "lazy",
		fetchpriority: isEager ? "high" : "auto",
		decoding: "async",
	};
};

/**
 * Warm the browser cache for a list of image URLs (deduped, once per session).
 */
export const preloadBettoImages = (urls) => {
	if (typeof window === "undefined") return;

	urls.forEach((url) => {
		if (!url || preloadedImageUrls.has(url)) return;

		preloadedImageUrls.add(url);
		const image = new window.Image();
		image.decoding = "async";
		image.src = url;
	});
};

/**
 * Split a numeric amount into whole and decimal parts for styled rendering.
 * e.g. 1234.56 → { whole: "1,234", decimals: ".56" }
 */
export const formatAmountParts = (amount) => {
	const formatted = Number(amount || 0).toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	const dotIndex = formatted.lastIndexOf(".");
	if (dotIndex === -1) return { whole: formatted, decimals: "" };
	return {
		whole: formatted.slice(0, dotIndex),
		decimals: formatted.slice(dotIndex),
	};
};

/**
 * Format a "days ago" offset into MM/DD/YYYY.
 */
export const formatDate = (offset) => {
	const date = new Date(Date.now() - offset * DAY_MS);
	const mm = String(date.getMonth() + 1).padStart(2, "0");
	const dd = String(date.getDate()).padStart(2, "0");
	return `${mm}/${dd}/${date.getFullYear()}`;
};

/**
 * Format a number as a US-locale string with exactly 2 decimal places.
 */
export const formatAmount = (num) =>
	Number(num || 0).toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
